module.exports = __webpack_public_path__ + "img/2.455856ab.png";